// Original standalone worksheet runtime, copied from our editor. No Fabric dependency.
export function buildHTMLFromExportData(data) {
  const exportJson = JSON.stringify(data, null, 2).replace(/</g, "\\u003c");

  return `<!DOCTYPE html>
<html lang="ru">
<head>
<meta charset="UTF-8">
<title>Викторина</title>

<style>
body{
    margin:0;
    padding:20px;
    font-family:Arial,sans-serif;
    background:#f0f0f0;
    color:#222;
}

.container{
    width:fit-content;
    margin:0 auto;
}

.top-panel,
.bottom-panel,
.result-panel,
.teacher-panel{
    width:${data.width}px;
    margin:0 auto 16px auto;
}

.hidden{
    display:none;
}

#secret{
    position:fixed;
    top:0;
    right:0;
    width:20px;
    height:20px;
    z-index:9999;
}

#worksheet{
    position:relative;
    width:${data.width}px;
    height:${data.height}px;
    margin:0 auto 16px auto;
    background:${data.native && data.background === "transparent" ? "transparent" : "white"};
    isolation:isolate;
    border:1px solid #ccc;
    overflow:hidden;
}

.element{
    position:absolute;
    box-sizing:border-box;
}

.conditional-hidden{
    display:none !important;
}

.decor-text{
    white-space:pre-wrap;
    pointer-events:none;
}

.decor-image,
.decor-shape{
    pointer-events:none;
}

.choice-option{
    border:1px solid #95a5a6;
    border-radius:10px;
    background:#ffffff;
    color:#2c3e50;
    cursor:pointer;
    user-select:none;
    box-sizing:border-box;
    position:absolute;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    overflow:visible;
}

.choice-option.locked{
    cursor:default;
}

.choice-option.locked:not(.selected-correct):not(.selected-wrong){
    cursor:not-allowed;
}

.choice-option.selected-correct,
.choice-option.selected-wrong{
    border-width:4px !important;
    font-weight:700;
}

.choice-option.selected-correct{
    border-color:#27ae60 !important;
    box-shadow:0 0 0 2px rgba(39, 174, 96, .22);
}

.choice-option.selected-wrong{
    border-color:#e74c3c !important;
    box-shadow:0 0 0 2px rgba(231, 76, 60, .22);
}

.input-field{
    border:1px solid #95a5a6;
    border-radius:10px;
    padding:8px 12px;
    font-size:16px;
    box-sizing:border-box;
}

.quiz-button{
    background:#3498db;
    color:white;
    border-radius:10px;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    box-sizing:border-box;
    cursor:pointer;
    user-select:none;
}

.drop-zone{
    box-sizing:border-box;
}

.drag-item{
    border:2px solid #d35400;
    background:#fef3c7;
    border-radius:10px;
    color:#7a3e00;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    box-sizing:border-box;
    user-select:none;
    cursor:grab;
    touch-action:none;
}

.drag-item.dragging{
    cursor:grabbing;
    opacity:0.9;
}

.drop-zone.active-zone{
    outline:3px solid rgba(52,152,219,0.35);
}

.drop-zone.filled-zone{
    background:rgba(46, 204, 113, 0.14);
}

table{
    width:100%;
    border-collapse:collapse;
    background:white;
    color:black;
}

td,th{
    border:1px solid #ccc;
    padding:6px;
}

.main-action-btn{
    padding:10px 18px;
    border:1px solid #999;
    background:white;
    cursor:pointer;
    font-size:16px;
}

  @keyframes wiggleX {
    0%, 100% { transform: var(--base-transform) translateX(0); }
    25% { transform: var(--base-transform) translateX(-6px); }
    75% { transform: var(--base-transform) translateX(6px); }
}

@keyframes wiggleY {
    0%, 100% { transform: var(--base-transform) translateY(0); }
    25% { transform: var(--base-transform) translateY(-6px); }
    75% { transform: var(--base-transform) translateY(6px); }
}

@keyframes springAnim {
    0% { transform: var(--base-transform) scale(1); }
    40% { transform: var(--base-transform) scale(1.12); }
    70% { transform: var(--base-transform) scale(0.94); }
    100% { transform: var(--base-transform) scale(1); }
}

@keyframes tiltAnim {
    0%, 100% { transform: var(--base-transform) rotate(0deg); }
    25% { transform: var(--base-transform) rotate(-8deg); }
    75% { transform: var(--base-transform) rotate(8deg); }
}

@keyframes spinAnim {
    from { transform: var(--base-transform) rotate(0deg); }
    to { transform: var(--base-transform) rotate(360deg); }
}

@keyframes fadeOutAnim {
    0% { opacity: 1; }
    100% { opacity: 0.15; }
}

@keyframes moveXAnim {
    0%, 100% { transform: var(--base-transform) translateX(0); }
    50% { transform: var(--base-transform) translateX(14px); }
}

@keyframes shakeAnim {
    0%, 100% { transform: var(--base-transform) translateX(0); }
    20% { transform: var(--base-transform) translateX(-4px); }
    40% { transform: var(--base-transform) translateX(4px); }
    60% { transform: var(--base-transform) translateX(-4px); }
    80% { transform: var(--base-transform) translateX(4px); }
}  
</style>
</head>
<body>

<div id="secret"></div>

<div class="container">

<div id="worksheet"></div>

<div id="result" class="hidden result-panel">
    <h2 id="score"></h2>
    <button class="main-action-btn" onclick="location.reload()">Заново</button>
</div>

<div id="teacher" class="hidden teacher-panel">
    <h2>Результаты</h2>
    <table id="table"></table>
</div>

</div>

<script>
const exportData = ${exportJson};
    const STORAGE_KEY = "creatorenginepro_native_attempt_" + (exportData.projectId || "preview");
const SCREEN_KEY = exportData.fileName || exportData.screenId || "screen_unknown";
let memoryAttemptData = null;

function createEmptyAttemptData() {
    return {
        attemptId: "",
        studentName: "",
        startedAt: "",
        lastActivityAt: "",
        lastResult: 0,
        totalResult: 0,
        currentScreenId: SCREEN_KEY,
        screens: {}
    };
}

function getAttemptData() {
    if (memoryAttemptData) {
        return JSON.parse(JSON.stringify(memoryAttemptData));
    }

    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (!parsed || typeof parsed !== "object") return createEmptyAttemptData();

        parsed.attemptId = parsed.attemptId || "";
        parsed.studentName = parsed.studentName || "";
        parsed.startedAt = parsed.startedAt || "";
        parsed.lastActivityAt = parsed.lastActivityAt || "";
        parsed.lastResult = Number(parsed.lastResult || 0);
        parsed.totalResult = Number(parsed.totalResult || 0);
        parsed.currentScreenId = parsed.currentScreenId || SCREEN_KEY;
        parsed.screens = parsed.screens && typeof parsed.screens === "object" ? parsed.screens : {};

        return parsed;
    } catch (e) {
        return createEmptyAttemptData();
    }
}

function saveAttemptData(data) {
    memoryAttemptData = JSON.parse(JSON.stringify(data));

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
        // In blob preview pages localStorage can be unavailable. Keep the attempt in memory.
    }
}

function ensureAttemptStarted() {
    const data = getAttemptData();
    const now = new Date().toISOString();

    if (!data.attemptId) {
        data.attemptId = "attempt_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
    }

    if (!data.startedAt) {
        data.startedAt = now;
    }

    data.lastActivityAt = now;
    data.currentScreenId = SCREEN_KEY;

    if (!data.screens[SCREEN_KEY]) {
        data.screens[SCREEN_KEY] = {
            opened: true,
            completed: false,
            score: null,
            maxScore: 0
        };
    } else {
        data.screens[SCREEN_KEY].opened = true;
    }

    saveAttemptData(data);
    return data;
}

function getDynamicTextValue(type) {
    const data = getAttemptData();

    if (type === 'studentName') return data.studentName || '';
    if (type === 'lastResult') return String(data.lastResult ?? '');
    if (type === 'totalResult') return String(data.totalResult ?? '');

    return '';
}

  function getScreenMaxScore() {
    let maxScore = 0;

    exportData.elements.forEach(el => {
        if (el.role === "choiceOption" && el.isCorrectOption) {
            maxScore += Number(el.scoreValue || 1);
        }

        if (el.role === "inputField") {
            const correct = (el.correctValue || "").trim();
            if (correct) {
                maxScore += Number(el.scoreValue || 1);
            }
        }

        if (el.role === "dragItem") {
            if (el.targetId) {
                maxScore += Number(el.scoreValue || 1);
            }
        }
    });

    return maxScore;
}  

function goToScreen(fileName) {
    if (!fileName) return;
    window.location.href = fileName + '.html';
}

function isStudentNameInputElement(elOrInput) {
    const source = [
        elOrInput?.questionId,
        elOrInput?.objectId,
        elOrInput?.displayText,
        elOrInput?.placeholder,
        elOrInput?.dataset?.questionId,
        elOrInput?.dataset?.objectId
    ].filter(Boolean).join(' ').toLowerCase();

    return /(^|[^a-zа-я])(student|name|fio|фио|имя|ученик|ученица)([^a-zа-я]|$)/i.test(source);
}

function saveStudentNameFromInputs() {
    const data = getAttemptData();

    const inputs = Array.from(document.querySelectorAll('.input-field'));
    const nameInput = inputs.find(input => input.dataset.isStudentName === "1" && input.value && input.value.trim());
    const firstFilledInput = inputs.find(input => input.value && input.value.trim());
    const sourceInput = nameInput || (!data.studentName ? firstFilledInput : null);

    if (sourceInput) {
        data.studentName = sourceInput.value.trim();
        saveAttemptData(data);
    }
}

function playSoundFile(fileName) {
    if (!fileName) return;

    const audio = new Audio(getAssetUrl("sounds", fileName));
    audio.play().catch(() => {});
}

function getAssetUrl(folder, fileName) {
    if (!fileName) return "";
    if (/^(data:|blob:|https?:|file:)/i.test(fileName)) return fileName;
    return folder + "/" + fileName;
}

function runAnimation(el, animationName) {
    if (!el || !animationName || animationName === 'none') return;

    el.style.animation = 'none';
    void el.offsetWidth;

    if (animationName === 'wiggle-x') {
        el.style.animation = 'wiggleX 0.35s ease-in-out';
    }

    if (animationName === 'wiggle-y') {
        el.style.animation = 'wiggleY 0.35s ease-in-out';
    }

    if (animationName === 'spring') {
        el.style.animation = 'springAnim 0.4s ease';
    }

    if (animationName === 'tilt') {
        el.style.animation = 'tiltAnim 0.35s ease-in-out';
    }

    if (animationName === 'spin') {
        el.style.animation = 'spinAnim 0.7s linear';
    }

    if (animationName === 'fade-out') {
        el.style.animation = 'fadeOutAnim 0.35s ease forwards';
        setTimeout(() => {
            el.style.opacity = '1';
            el.style.animation = 'none';
        }, 380);
        return;
    }

    if (animationName === 'move-x') {
        el.style.animation = 'moveXAnim 0.45s ease-in-out';
    }

    if (animationName === 'shake') {
        el.style.animation = 'shakeAnim 0.25s linear';
    }

    el.addEventListener('animationend', function handler() {
        el.style.animation = 'none';
        el.removeEventListener('animationend', handler);
    });
}

function attachInteractiveEffects(domEl, elData) {
    if (!domEl || !elData) return;

    domEl.addEventListener('mouseenter', () => {
        playSoundFile(elData.hoverSoundFileName);
        runAnimation(domEl, elData.hoverAnimation);
    });

    domEl.addEventListener('pointerdown', () => {
        playSoundFile(elData.clickSoundFileName);
        runAnimation(domEl, elData.clickAnimation);
    });

    domEl.addEventListener('pointerup', () => {
        playSoundFile(elData.releaseSoundFileName);
        runAnimation(domEl, elData.releaseAnimation);
    });
}

let choiceAnswers = {};
let inputAnswers = {};
let dragAnswers = {};

function getConditionalQuestionIds() {
    const ids = new Set();
    exportData.elements.forEach(el => {
        if (!["choiceOption", "inputField", "dragItem"].includes(el.role)) return;
        const questionId = String(el.questionId || "").trim();
        if (questionId) ids.add(questionId);
    });
    return Array.from(ids);
}

function getConditionalQuestionState(questionId) {
    const qid = String(questionId || "").trim();
    const checks = [];
    const choiceOptions = exportData.elements.filter(el => el.role === "choiceOption" && el.questionId === qid);

    if (choiceOptions.length) {
        const selectedId = choiceAnswers[qid] || "";
        const correctIds = choiceOptions.filter(el => el.isCorrectOption).map(el => el.objectId);
        checks.push({
            answered: !!selectedId,
            correct: !!selectedId && correctIds.includes(selectedId)
        });
    }

    exportData.elements.filter(el => el.role === "inputField" && el.questionId === qid).forEach(el => {
        const given = String(inputAnswers[el.objectId || ""] || "").trim();
        const expected = String(el.correctValue || "").trim();
        checks.push({
            answered: !!given,
            correct: !!given && (!expected || given.toLocaleLowerCase("ru-RU") === expected.toLocaleLowerCase("ru-RU"))
        });
    });

    exportData.elements.filter(el => el.role === "dragItem" && el.questionId === qid).forEach(el => {
        const given = String(dragAnswers[el.objectId || ""] || "").trim();
        const expected = String(el.targetId || "").trim();
        checks.push({
            answered: !!given,
            correct: !!given && !!expected && given === expected
        });
    });

    if (!checks.length) return { answered: false, correct: false };
    return {
        answered: checks.every(check => check.answered),
        correct: checks.every(check => check.correct)
    };
}

function isConditionalElementVisible(el) {
    if (!el.visibilityConditionEnabled) return true;
    const type = el.visibilityConditionType || "answered";

    if (type === "allAnswered" || type === "allCorrect") {
        const questionIds = getConditionalQuestionIds();
        if (!questionIds.length) return false;
        return questionIds.every(questionId => {
            const state = getConditionalQuestionState(questionId);
            return type === "allAnswered" ? state.answered : state.correct;
        });
    }

    const state = getConditionalQuestionState(el.visibilityQuestionId || "");
    return type === "correct" ? state.correct : state.answered;
}

function captureNativeProgress(completed) {
    if (!exportData.nativeSite) return;
    const data = getAttemptData();
    const prior = data.screens[SCREEN_KEY] || {};
    const answers = []; let mistakes = 0;
    exportData.elements.forEach(el => {
        let type, expected, given, correct;
        if (el.role === 'choiceOption' && el.isCorrectOption) {
            type = 'choice'; expected = el.displayText || el.objectId;
            const selected = exportData.elements.find(o => o.objectId === choiceAnswers[el.questionId || '']);
            given = selected ? selected.displayText || selected.objectId : ''; correct = selected?.objectId === el.objectId;
        } else if (el.role === 'inputField' && String(el.correctValue || '').trim()) {
            type = 'input'; expected = String(el.correctValue).trim(); given = String(inputAnswers[el.objectId] || '').trim();
            correct = given.toLocaleLowerCase('ru-RU') === expected.toLocaleLowerCase('ru-RU');
        } else if (el.role === 'dragItem' && el.targetId) {
            type = 'drag'; expected = el.targetId; given = dragAnswers[el.objectId] || ''; correct = given === expected;
        } else return;
        if (!correct) mistakes++;
        const mode = el.statsSaveMode || 'answerAndCorrectness';
        if (mode === 'none') return;
        const answer = {type, questionId:el.questionId || '', label:el.statsLabel || el.displayText || el.questionId || el.objectId || '', group:el.answerGroup || '', points:correct ? Number(el.scoreValue || 1) : 0, maxPoints:Number(el.scoreValue || 1)};
        if (mode === 'answerAndCorrectness' || mode === 'answerOnly') Object.assign(answer,{expected,given});
        if (mode === 'answerAndCorrectness' || mode === 'correctnessOnly') answer.correct = correct;
        answers.push(answer);
    });
    data.screens[SCREEN_KEY] = {...prior, screenName:exportData.screenName, fileName:exportData.fileName,
        completed:completed || prior.completed || false, mistakes, answers,
        responses:{choices:{...choiceAnswers}, inputs:{...inputAnswers}, drags:{...dragAnswers}}};
    data.lastActivityAt = new Date().toISOString(); saveAttemptData(data);
}
function updateConditionalVisibility() {
    exportData.elements.forEach(el => {
        if (!el.visibilityConditionEnabled || !el.objectId) return;
        const node = Array.from(document.querySelectorAll('[data-object-id]')).find(node => node.dataset.objectId === el.objectId);
        if (!node) return;
        const isVisible = isConditionalElementVisible(el);
        node.hidden = !isVisible;
        node.classList.toggle("conditional-hidden", !isVisible);
    });
    captureNativeProgress(false);
}

// Install transport before reading any local attempt data.
if (exportData.nativeSite && parent !== window && parent.creatorEngineSite) {
    const bridge = parent.creatorEngineSite;
    getAttemptData = bridge.read; saveAttemptData = bridge.write; goToScreen = bridge.show;
    const originalFetch = window.fetch.bind(window);
    window.fetch = (url, options) => String(url) === 'save.php'
        ? bridge.flush().then(() => new Response('ok'))
        : String(url) === 'results.php' ? Promise.resolve(new Response('[]')) : originalFetch(url, options);
    const responses = getAttemptData().screens[SCREEN_KEY]?.responses || {};
    choiceAnswers = responses.choices || {}; inputAnswers = responses.inputs || {}; dragAnswers = responses.drags || {};
} else if (exportData.nativePreview && parent !== window && parent.creatorEnginePreview) {
    const bridge = parent.creatorEnginePreview;
    getAttemptData = bridge.read; saveAttemptData = bridge.write; goToScreen = bridge.show;
    const originalFetch = window.fetch.bind(window);
    window.fetch = (url, options) => String(url) === 'save.php'
        ? Promise.resolve(new Response('ok'))
        : String(url) === 'results.php' ? Promise.resolve(new Response('[]')) : originalFetch(url, options);
}
ensureAttemptStarted();

const __attemptInitData = getAttemptData();
if (!__attemptInitData.screens[SCREEN_KEY]) {
    __attemptInitData.screens[SCREEN_KEY] = {
        opened: true,
        completed: false,
        score: null,
        maxScore: getScreenMaxScore(),
        fileName: exportData.fileName || "",
        screenName: exportData.screenName || exportData.fileName || SCREEN_KEY
    };
} else {
    __attemptInitData.screens[SCREEN_KEY].opened = true;
    __attemptInitData.screens[SCREEN_KEY].maxScore = getScreenMaxScore();
    __attemptInitData.screens[SCREEN_KEY].fileName = exportData.fileName || "";
    __attemptInitData.screens[SCREEN_KEY].screenName = exportData.screenName || exportData.fileName || SCREEN_KEY;
}
saveAttemptData(__attemptInitData);

renderWorksheet();

function getElementBaseTransform(el) {
    const rotation = "rotate(" + (el.angle || 0) + "deg)";
    const hasScale = (el.scaleX && el.scaleX !== 1) || (el.scaleY && el.scaleY !== 1);
    const scale = hasScale
        ? " scale(" + (el.scaleX || 1) + ", " + (el.scaleY || 1) + ")"
        : "";

    return el.anchor === "center"
        ? "translate(-50%, -50%) " + rotation + scale + (el.skewX ? " skewX(" + el.skewX + "deg)" : "")
        : rotation + scale + (el.skewX ? " skewX(" + el.skewX + "deg)" : "");
}

function applyElementTransform(domEl, el) {
    const baseTransform = getElementBaseTransform(el);
    const hasScale = (el.scaleX && el.scaleX !== 1) || (el.scaleY && el.scaleY !== 1);
    domEl.style.transform = baseTransform;
    domEl.style.transformOrigin = el.anchor === "topLeft" && hasScale ? "top left" : "center center";
    domEl.style.setProperty('--base-transform', baseTransform);
}

function getZoneElements() {
    return Array.from(document.querySelectorAll('.drop-zone'));
}

function getDragElements() {
    return Array.from(document.querySelectorAll('.drag-item'));
}

function clearZoneHighlight() {
    getZoneElements().forEach(zone => zone.classList.remove('active-zone'));
}

function findZoneUnderPoint(x, y) {
    const zones = getZoneElements();

    for (const zone of zones) {
        const rect = zone.getBoundingClientRect();
        if (
            x >= rect.left &&
            x <= rect.right &&
            y >= rect.top &&
            y <= rect.bottom
        ) {
            return zone;
        }
    }

    return null;
}

function markFilledZones() {
    const usedZoneIds = new Set(Object.values(dragAnswers).filter(Boolean));

    getZoneElements().forEach(zone => {
        if (usedZoneIds.has(zone.dataset.objectId)) {
            zone.classList.add('filled-zone');
        } else {
            zone.classList.remove('filled-zone');
        }
    });
}

function renderWorksheet(){
    const container = document.getElementById("worksheet");
    container.innerHTML = "";
    container.style.width = exportData.width + "px";
    container.style.height = exportData.height + "px";

    exportData.elements.forEach(el => {
 if (el.role === "decorText") {
    const div = document.createElement("div");

    div.className = "element decor-text";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";

    div.style.fontSize = (el.fontSize || 32) + "px";
    div.style.fontFamily = el.fontFamily || "Arial";
    div.style.fontWeight = el.fontWeight || "normal";
    div.style.fontStyle = el.fontStyle || "normal";
    div.style.color = el.fill || "#000";

    div.style.textAlign = el.textAlign || "left";
    div.style.whiteSpace = "pre";
    div.style.lineHeight = "1.1";
    div.style.overflow = "visible";
    div.style.wordBreak = "normal";
    div.style.overflowWrap = "normal";
    div.style.pointerEvents = "none";
    div.style.zIndex = el.zIndex || 1;

    applyElementTransform(div, el);

    div.textContent = el.dynamicTextType && el.dynamicTextType !== 'none'
        ? getDynamicTextValue(el.dynamicTextType)
        : (el.text || "");

    container.appendChild(div);
}

if (el.role === "decorTextField") {
    const div = document.createElement("div");

    div.className = "element decor-text";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";

    div.style.fontSize = (el.fontSize || 28) + "px";
    div.style.fontFamily = el.fontFamily || "Arial";
    div.style.fontWeight = el.fontWeight || "normal";
    div.style.fontStyle = el.fontStyle || "normal";
    div.style.color = el.fill || "#000";
    div.style.textAlign = el.textAlign || "left";

    div.style.display = "block";
    div.style.boxSizing = "border-box";
    div.style.whiteSpace = "pre-wrap";
    div.style.lineHeight = "1.2";
    div.style.overflow = el.isTextField ? "visible" : "hidden";
    div.style.wordBreak = "normal";
    div.style.overflowWrap = "break-word";
    div.style.pointerEvents = "none";
    div.style.zIndex = el.zIndex || 1;
    div.style.padding = el.isTextField ? "0" : "10px";

    applyElementTransform(div, el);

    div.textContent =
        el.dynamicTextType && el.dynamicTextType !== 'none'
            ? getDynamicTextValue(el.dynamicTextType)
            : (el.text || "");

    container.appendChild(div);
}

        if (el.role === "decorShape") {
    const div = document.createElement("div");
    div.className = "element decor-shape";
    div.style.pointerEvents = "none";
            div.style.left = el.x + "px";
            div.style.top = el.y + "px";
            div.style.width = el.width + "px";
            div.style.height = el.height + "px";
    div.style.zIndex = el.zIndex || 1;
    if (el.angle) {
    applyElementTransform(div, el);
}
            div.style.background = el.fill || "transparent";
            const borderStyle = Array.isArray(el.strokeDashArray) && el.strokeDashArray.length ? "dashed" : "solid";
            div.style.border = (el.strokeWidth || 0) + "px " + borderStyle + " " + (el.stroke || "transparent");
            if (el.shapeType === "circle") {
                div.style.borderRadius = "50%";
            } else {
                div.style.borderRadius = (el.rx || 0) + "px";
            }
            container.appendChild(div);
        }

        if (el.role === "decorImage") {
    const img = document.createElement("img");
    img.className = "element decor-image";
    img.style.pointerEvents = "none";
            img.src = getAssetUrl("images", el.imageFileName || "");
            img.style.left = el.x + "px";
            img.style.top = el.y + "px";
            img.style.width = el.width + "px";
            img.style.height = el.height + "px";
    img.style.zIndex = el.zIndex || 1;
    if (el.angle) {
    applyElementTransform(img, el);
}
            container.appendChild(img);
        }

if (el.role === "quizButton") {
    const div = document.createElement("div");
    div.className = "element quiz-button";
    div.dataset.objectId = el.objectId || "";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";
    div.style.zIndex = el.zIndex || 1;

    div.style.transform = "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)";
    div.style.setProperty('--base-transform', "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)");
    div.style.transformOrigin = "center center";

    if (el.interactiveImageEnabled && el.interactiveImageFileName) {
        div.style.background = "transparent";
        div.style.border = "none";

        const img = document.createElement("img");
        img.src = getAssetUrl("images", el.interactiveImageFileName);
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "contain";
        img.style.pointerEvents = "none";
        div.appendChild(img);
    } else {
        div.style.background = el.fill || "#3498db";
        const borderStyle = Array.isArray(el.strokeDashArray) && el.strokeDashArray.length ? "dashed" : "solid";
        div.style.border = (el.strokeWidth || 0) + "px " + borderStyle + " " + (el.stroke || "transparent");
        div.style.borderRadius = (el.rx || 10) + "px";
        div.style.color = el.textFill || "#ffffff";
        div.style.fontSize = (el.fontSize || 22) + "px";
        div.style.fontFamily = el.fontFamily || "Arial";
        div.textContent = el.displayText || "Кнопка";
    }

    container.appendChild(div);
    attachInteractiveEffects(div, el);
    div.addEventListener('click', async () => {
        saveStudentNameFromInputs();

        const hasCheckableElements = exportData.elements.some(item =>
            item.role === "choiceOption" ||
            item.role === "inputField" ||
            item.role === "dragItem"
        );

        if (hasCheckableElements) {
            finishQuiz();

            await new Promise(resolve => setTimeout(resolve, 250));
        }

        goToScreen(el.targetScreenFileName || '');
    });
}

function enableDragAndDrop(element, elData) {
    let startX = 0;
    let startY = 0;
    let originLeft = 0;
    let originTop = 0;
    let dragging = false;

    const onPointerMove = (e) => {
        if (!dragging) return;

        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        element.style.left = (originLeft + dx) + 'px';
        element.style.top = (originTop + dy) + 'px';

        const zone = findZoneUnderPoint(e.clientX, e.clientY);
        clearZoneHighlight();
        if (zone) {
            zone.classList.add('active-zone');
        }
    };

    const onPointerUp = (e) => {
        if (!dragging) return;

        dragging = false;
        element.classList.remove('dragging');
        clearZoneHighlight();

        playSoundFile(elData?.releaseSoundFileName);
        runAnimation(element, elData?.releaseAnimation);

        const zone = findZoneUnderPoint(e.clientX, e.clientY);

        if (zone) {
    dragAnswers[element.dataset.objectId] = zone.dataset.targetId || '';

            const zoneRect = zone.getBoundingClientRect();
            const worksheetRect = document.getElementById('worksheet').getBoundingClientRect();

            const zoneCenterX = zoneRect.left - worksheetRect.left + zoneRect.width / 2;
            const zoneCenterY = zoneRect.top - worksheetRect.top + zoneRect.height / 2;

            element.style.left = zoneCenterX + 'px';
            element.style.top = zoneCenterY + 'px';
        } else {
            dragAnswers[element.dataset.objectId] = '';
        }

        markFilledZones();
        updateConditionalVisibility();

        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
    };

    element.addEventListener('pointerdown', (e) => {
        e.preventDefault();

        dragging = true;
        element.classList.add('dragging');

        playSoundFile(elData?.clickSoundFileName);
        runAnimation(element, elData?.clickAnimation);

        startX = e.clientX;
        startY = e.clientY;

        originLeft = parseFloat(element.style.left) || 0;
        originTop = parseFloat(element.style.top) || 0;

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
    });
}

if (el.role === "choiceOption") {
    const div = document.createElement("div");
    div.className = "element choice-option";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";
    div.style.zIndex = el.zIndex || 1;
    div.style.lineHeight = "1.1";
    div.style.whiteSpace = "pre-line";
    div.style.transform = "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)";
    div.style.setProperty('--base-transform', "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)");
    div.style.transformOrigin = "center center";

    if (el.interactiveImageEnabled && el.interactiveImageFileName) {
        div.style.background = "transparent";
        div.style.border = "none";

        const img = document.createElement("img");
        img.src = getAssetUrl("images", el.interactiveImageFileName);
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "contain";
        img.style.pointerEvents = "none";
        div.appendChild(img);
    } else {
        div.style.background = el.fill || "#ffffff";
        const borderStyle = Array.isArray(el.strokeDashArray) && el.strokeDashArray.length ? "dashed" : "solid";
        div.style.border = (el.strokeWidth || 1) + "px " + borderStyle + " " + (el.stroke || "#95a5a6");
        div.style.borderRadius = (el.rx || 10) + "px";
        div.style.color = el.textFill || "#2c3e50";
        div.style.fontSize = (el.fontSize || 22) + "px";
        div.style.fontFamily = el.fontFamily || "Arial";

        const inner = document.createElement("div");
        inner.style.width = "90%";
        inner.style.textAlign = "center";
        inner.style.whiteSpace = "pre-line";
        inner.style.lineHeight = "1.1";
        inner.textContent = el.displayText || "Вариант ответа";

        div.appendChild(inner);
    }

    div.dataset.questionId = el.questionId || "";
    div.dataset.objectId = el.objectId || "";
    div.dataset.correct = el.isCorrectOption ? "1" : "0";

    div.onclick = () => {
        const qid = div.dataset.questionId;
        if (Object.prototype.hasOwnProperty.call(choiceAnswers, qid)) {
            return;
        }

        const groupOptions = Array.from(document.querySelectorAll('.choice-option'))
            .filter(item => item.dataset.questionId === qid);

        groupOptions.forEach(item => {
            item.classList.add("locked");
            item.setAttribute("aria-disabled", "true");
        });

        div.classList.add(div.dataset.correct === "1" ? "selected-correct" : "selected-wrong");
        div.setAttribute("aria-pressed", "true");
        choiceAnswers[qid] = div.dataset.objectId;
        updateConditionalVisibility();
    };

    container.appendChild(div);
    attachInteractiveEffects(div, el);
}

       if (el.role === "inputField") {
    const input = document.createElement("input");
    input.className = "element input-field";

    input.style.left = el.x + "px";
    input.style.top = el.y + "px";
    input.style.width = Math.max(60, el.width - 24) + "px";
    input.style.height = Math.max(30, el.height - 20) + "px";
    input.style.zIndex = el.zIndex || 1;

    input.style.transform = "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)";
    input.style.setProperty('--base-transform', "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)");
    input.style.transformOrigin = "center center";

    input.placeholder = el.displayText || "Введите ответ";
    input.dataset.objectId = el.objectId || "";
    input.dataset.questionId = el.questionId || "";
    input.dataset.correctValue = el.correctValue || "";
    input.dataset.isStudentName = isStudentNameInputElement(el) ? "1" : "0";
    const savedAttempt = getAttemptData();
if (input.dataset.isStudentName === "1" && savedAttempt.studentName && !input.value) {
    input.value = savedAttempt.studentName;
}

    input.addEventListener("input", () => {
        if (input.dataset.isStudentName !== "1") {
            const upperValue = input.value.toLocaleUpperCase("ru-RU");
            if (input.value !== upperValue) {
                input.value = upperValue;
            }
        }
        inputAnswers[input.dataset.objectId] = input.value;
        updateConditionalVisibility();
    });

    container.appendChild(input);
    attachInteractiveEffects(input, el);
}

    if (el.role === "dragItem") {
    const div = document.createElement("div");
    div.className = "element drag-item";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";
    div.style.zIndex = el.zIndex || 1;

    div.style.transform = "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)";
    div.style.setProperty('--base-transform', "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)");
    div.style.transformOrigin = "center center";

    if (el.interactiveImageEnabled && el.interactiveImageFileName) {
        div.style.background = "transparent";
        div.style.border = "none";

        const img = document.createElement("img");
        img.src = getAssetUrl("images", el.interactiveImageFileName);
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "contain";
        img.style.pointerEvents = "none";
        div.appendChild(img);
    } else {
        div.textContent = el.displayText || "Перетаскиваемый элемент";
        div.style.background = el.fill || "#fef3c7";
        const borderStyle = Array.isArray(el.strokeDashArray) && el.strokeDashArray.length ? "dashed" : "solid";
        div.style.border = (el.strokeWidth || 2) + "px " + borderStyle + " " + (el.stroke || "#d35400");
        div.style.borderRadius = (el.rx || 10) + "px";
        div.style.color = el.textFill || "#7a3e00";
        div.style.fontSize = (el.fontSize || 20) + "px";
        div.style.fontFamily = el.fontFamily || "Arial";
    }

    div.dataset.objectId = el.objectId || "";
    div.dataset.targetId = el.targetId || "";
    div.dataset.scoreValue = el.scoreValue || 1;

    container.appendChild(div);
    attachInteractiveEffects(div, el);
    enableDragAndDrop(div, el);
}

if (el.role === "dropZone") {
    const div = document.createElement("div");
    div.className = "element drop-zone";

    div.style.left = el.x + "px";
    div.style.top = el.y + "px";
    div.style.width = el.width + "px";
    div.style.height = el.height + "px";
    div.style.zIndex = el.zIndex || 1;

    div.style.transform = "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)";
    div.style.setProperty('--base-transform', "translate(-50%, -50%) rotate(" + (el.angle || 0) + "deg)");
    div.style.transformOrigin = "center center";

    if (el.interactiveImageEnabled && el.interactiveImageFileName) {
        div.style.background = "transparent";
        div.style.border = "none";

        const img = document.createElement("img");
        img.src = getAssetUrl("images", el.interactiveImageFileName);
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "contain";
        img.style.pointerEvents = "none";
        div.appendChild(img);
    } else {
        div.style.background = el.fill || "rgba(52,152,219,0.08)";
        const borderStyle = Array.isArray(el.strokeDashArray) && el.strokeDashArray.length ? "dashed" : "solid";
        div.style.border = (el.strokeWidth || 2) + "px " + borderStyle + " " + (el.stroke || "#3498db");
        div.style.borderRadius = (el.rx || 0) + "px";
        div.style.display = "flex";
        div.style.alignItems = "center";
        div.style.justifyContent = "center";
        div.style.textAlign = "center";
        div.style.padding = "8px";
        div.style.color = el.textFill || "#3b4b57";
        div.style.fontSize = (el.fontSize || 18) + "px";
        div.style.fontFamily = el.fontFamily || "Arial";
        div.style.boxSizing = "border-box";
        div.textContent = el.displayText || "";
    }

    div.dataset.objectId = el.objectId || "";
    div.dataset.targetId = el.targetId || "";

    container.appendChild(div);
    attachInteractiveEffects(div, el);
}


    });
    if (exportData.native) {
        Array.from(container.children).forEach((dom, index) => {
            const el = exportData.elements[index];
            if (!el) return;
            applyElementTransform(dom, el);
            dom.style.opacity = el.opacity == null ? 1 : el.opacity;
            dom.style.mixBlendMode = el.blendMode === 'source-over' ? 'normal' : (el.blendMode || 'normal');
            if (['quizButton','inputField','choiceOption','dropZone','dragItem'].includes(el.role)) {
                dom.style.boxSizing = 'border-box';
                dom.style.width = el.width + 'px';
                dom.style.height = el.height + 'px';
                dom.style.fontSize = el.fontSize + 'px';
                dom.style.fontFamily = el.fontFamily || 'Arial';
                dom.style.color = el.textFill || '#000000';
                if (!el.interactiveImageEnabled) {
                    dom.style.borderWidth = (el.strokeWidth || 0) + 'px';
                    dom.style.borderColor = el.stroke || 'transparent';
                    dom.style.borderRadius = (el.rx || 0) + 'px';
                    dom.style.background = el.fill || 'transparent';
                }
                dom.setAttribute('aria-label', el.displayText || '');
            }
            if (el.nativeLive && window.CreatorNativeLive) void window.CreatorNativeLive.mount(dom,el,exportData.liveDocument).catch(error=>{const message=document.createElement('p');message.setAttribute('role','alert');message.textContent='Не удалось отрисовать элемент: '+error.message;document.body.append(message);});
        });
    }
    if (exportData.nativeSite) {
        container.querySelectorAll('.input-field').forEach(input => { if (inputAnswers[input.dataset.objectId] != null) input.value = inputAnswers[input.dataset.objectId]; });
        container.querySelectorAll('.choice-option').forEach(node => { const chosen = choiceAnswers[node.dataset.questionId]; if (!chosen) return; node.classList.add('locked'); node.setAttribute('aria-disabled','true'); if (chosen === node.dataset.objectId) { node.classList.add(node.dataset.correct === '1' ? 'selected-correct' : 'selected-wrong'); node.setAttribute('aria-pressed','true'); } });
        container.querySelectorAll('.drag-item').forEach(node => { const target = dragAnswers[node.dataset.objectId]; const zone = Array.from(container.querySelectorAll('.drop-zone')).find(z => z.dataset.objectId === target || z.dataset.targetId === target); if(zone) {node.style.left = zone.style.left; node.style.top = zone.style.top;} });
        const scale = () => { const factor = Math.min(1, innerWidth / exportData.width); const holder = document.querySelector('.container'); holder.style.transformOrigin = 'top left'; holder.style.transform = 'scale('+factor+')'; holder.style.margin = '0'; document.body.style.height = exportData.height * factor + 'px'; };
        const css = document.createElement('style'); css.textContent = 'body{padding:0;overflow-x:hidden}.top-panel,.bottom-panel,#secret,#teacher{display:none!important}'; document.head.append(css); addEventListener('resize',scale); scale();
    }
    updateConditionalVisibility();
}

function finishQuiz(){
    let score = 0;

exportData.elements.forEach(el => {
    if (el.role === "choiceOption" && el.isCorrectOption) {
        const selectedId = choiceAnswers[el.questionId || ""];
        if (selectedId && selectedId === el.objectId) {
            score += Number(el.scoreValue || 1);
        }
    }

    if (el.role === "inputField") {
        const value = (inputAnswers[el.objectId || ""] || "").trim().toLocaleLowerCase("ru-RU");
        const correct = (el.correctValue || "").trim().toLocaleLowerCase("ru-RU");
        if (correct && value === correct) {
            score += Number(el.scoreValue || 1);
        }
    }

if (el.role === "dragItem") {
    const droppedZoneTargetId = dragAnswers[el.objectId || ""];
    const correctTargetId = el.targetId || "";

    if (droppedZoneTargetId && correctTargetId && droppedZoneTargetId === correctTargetId) {
        score += Number(el.scoreValue || 1);
    }
}
});

    const data = ensureAttemptStarted();
    const maxScore = getScreenMaxScore();

    if (!data.screens[SCREEN_KEY]) {
    data.screens[SCREEN_KEY] = {
        opened: true,
        completed: true,
        score: score,
        maxScore: maxScore,
        fileName: exportData.fileName || "",
        screenName: exportData.screenName || exportData.fileName || SCREEN_KEY
    };
} else {
    data.screens[SCREEN_KEY].opened = true;
    data.screens[SCREEN_KEY].completed = true;
    data.screens[SCREEN_KEY].score = score;
    data.screens[SCREEN_KEY].maxScore = maxScore;
    data.screens[SCREEN_KEY].fileName = exportData.fileName || "";
    data.screens[SCREEN_KEY].screenName = exportData.screenName || exportData.fileName || SCREEN_KEY;
}

    data.lastResult = score;
    data.totalResult = Object.values(data.screens).reduce((sum, screen) => {
        return sum + (screen && typeof screen.score === "number" ? screen.score : 0);
    }, 0);

    saveStudentNameFromInputs();
    const updatedData = getAttemptData();
    updatedData.lastResult = data.lastResult;
    updatedData.totalResult = data.totalResult;
    updatedData.currentScreenId = SCREEN_KEY;
    updatedData.lastActivityAt = new Date().toISOString();

    if (!updatedData.screens[SCREEN_KEY]) {
    updatedData.screens[SCREEN_KEY] = data.screens[SCREEN_KEY];
} else {
    updatedData.screens[SCREEN_KEY].opened = true;
    updatedData.screens[SCREEN_KEY].completed = true;
    updatedData.screens[SCREEN_KEY].score = score;
    updatedData.screens[SCREEN_KEY].maxScore = maxScore;
    updatedData.screens[SCREEN_KEY].fileName = exportData.fileName || "";
    updatedData.screens[SCREEN_KEY].screenName = exportData.screenName || exportData.fileName || SCREEN_KEY;
}

    saveAttemptData(updatedData);
    captureNativeProgress(true);
    saveResult();
}

function saveResult(){
    const data = getAttemptData();

    fetch("save.php", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            attemptId: data.attemptId || "",
            studentName: data.studentName || "",
            startedAt: data.startedAt || "",
            lastActivityAt: data.lastActivityAt || "",
            currentScreenId: data.currentScreenId || "",
            lastResult: Number(data.lastResult || 0),
            totalResult: Number(data.totalResult || 0),
            screens: data.screens || {}
        })
    })
    .then(r => r.text())
    .then(text => {
        console.log("save.php:", text);
    })
    .catch(err => {
        console.error("Ошибка сохранения:", err);
    });
}

document.getElementById("secret").onclick = () => {
    const code = prompt("Введите пароль");
    if (code === null) return;

    if (code !== "1234") {
        alert("Неверный пароль");
        return;
    }

    loadResults();
};

function loadResults(){
    fetch("results.php", {
        cache: "no-store"
    })
    .then(async r => {
        const text = await r.text();

        if (!r.ok) {
            throw new Error("results.php вернул ошибку: " + r.status + "\\n" + text);
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            throw new Error("results.php вернул не JSON:\\n" + text);
        }
    })
    .then(rows => {
        document.getElementById("teacher").classList.remove("hidden");

        const t = document.getElementById("table");
        t.innerHTML = "";

        const screenMap = new Map();

        rows.forEach(item => {
            const screens = item.screens || {};

            Object.keys(screens).forEach(screenId => {
                const screen = screens[screenId] || {};
                const maxScore = Number(screen.maxScore || 0);

if (
    maxScore > 0 &&
    screen.fileName &&
    !String(screen.fileName).startsWith("screen_")
) {
    const fileName = String(screen.fileName);
    const screenName = screen.screenName || fileName;

    if (!screenMap.has(fileName)) {
        screenMap.set(fileName, {
            fileName,
            screenName
        });
    }
}
            });
        });

        const taskScreens = Array.from(screenMap.values()).sort((a, b) =>
            a.fileName.localeCompare(b.fileName, 'ru')
        );

        const header = t.insertRow();
        header.insertCell().outerHTML = "<th>№</th>";
        header.insertCell().outerHTML = "<th>Ученик</th>";

        taskScreens.forEach(screenInfo => {
            const th = document.createElement("th");
            th.textContent = screenInfo.screenName;
            header.appendChild(th);
        });

        header.insertCell().outerHTML = "<th>Итого</th>";

        rows.forEach((item, rowIndex) => {
            const row = t.insertRow();

            row.insertCell().innerText = rowIndex + 1;
            row.insertCell().innerText = item.studentName || "";

            const screens = item.screens || {};

            taskScreens.forEach(screenInfo => {
                const cell = row.insertCell();

const screenEntry = Object.values(screens).find(s =>
    s.fileName &&
    !String(s.fileName).startsWith("screen_") &&
    s.fileName === screenInfo.fileName
);

                if (!screenEntry || !screenEntry.opened) {
                    cell.innerText = "—";
                    return;
                }

                const score = typeof screenEntry.score === "number" ? screenEntry.score : null;
                const maxScore = Number(screenEntry.maxScore || 0);

                if (score === null) {
                    cell.innerText = "—";
                } else {
                    cell.innerText = score + "/" + maxScore;
                }
            });

            row.insertCell().innerText = Number(item.totalResult || 0);
        });

        if (!rows.length) {
            const row = t.insertRow();
            const cell = row.insertCell();
            cell.colSpan = 3;
            cell.innerText = "Пока нет результатов";
        }
    })
    .catch(err => {
        console.error(err);
        alert(err.message);
    });
}
</script>

</body>
</html>`;
}
export function buildSavePhp() {
  return `<?php
header("Content-Type: text/plain; charset=utf-8");

$data = json_decode(file_get_contents("php://input"), true);

if (!is_array($data)) {
    http_response_code(400);
    echo "invalid json";
    exit;
}

$file = "results.json";

if (!file_exists($file)) {
    file_put_contents($file, "[]");
}

$rows = json_decode(file_get_contents($file), true);

if (!is_array($rows)) {
    $rows = [];
}

$attemptId = trim((string)($data["attemptId"] ?? ""));
if ($attemptId === "") {
    $attemptId = "attempt_" . uniqid();
}

$newRow = [
    "attemptId" => $attemptId,
    "studentName" => (string)($data["studentName"] ?? ""),
    "startedAt" => (string)($data["startedAt"] ?? ""),
    "lastActivityAt" => (string)($data["lastActivityAt"] ?? date("c")),
    "currentScreenId" => (string)($data["currentScreenId"] ?? ""),
    "lastResult" => (float)($data["lastResult"] ?? 0),
    "totalResult" => (float)($data["totalResult"] ?? 0),
    "screens" => is_array($data["screens"] ?? null) ? $data["screens"] : []
];

$updated = false;

for ($i = 0; $i < count($rows); $i++) {

    if (($rows[$i]["attemptId"] ?? "") === $attemptId) {

        $oldScreens = is_array($rows[$i]["screens"] ?? null)
            ? $rows[$i]["screens"]
            : [];

        $rows[$i] = $newRow;
        $rows[$i]["screens"] =
            array_merge($oldScreens, $newRow["screens"]);

        $updated = true;
        break;
    }
}

if (!$updated) {
    $rows[] = $newRow;
}

file_put_contents(
    $file,
    json_encode($rows, JSON_UNESCAPED_UNICODE | JSON_PRETTY_PRINT)
);

echo "ok";
`;
}
export function buildResultsPhp() {
  return `<?php
header("Content-Type: application/json; charset=utf-8");

$file = "results.json";

if (!file_exists($file)) {
    file_put_contents($file, "[]");
}

$data = file_get_contents($file);

if (!$data) {
    echo "[]";
    exit;
}

echo $data;
`;
}
export function buildEmptyResultsJson() {
  return `[]`;
}
